import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { EventSubmissionAnswerDialogModule } from '@main-client/src/app/events/event-submission-answer-dialog/event-submission-answer-dialog.module';
import { AccountFullNamePipeModule } from '@main-client/src/app/pipes/account-full-name-pipe/account-full-name-pipe.module';
import { DeletedUserFallbackPipeModule } from '@main-client/src/app/pipes/deleted-user-fallback-pipe/deleted-user-fallback-pipe.module';
import { TtcMatPaginatorModule } from '@main-client/src/app/ttc-mat-paginator/ttc-mat-paginator.module';

import { FormService } from '@main-client/src/app/form/form.service';

import { EventParticipantsComponent } from './event-participants.component';

@NgModule({
  imports: [
    AccountFullNamePipeModule,
    AvatarModule,
    CommonModule,
    DeletedUserFallbackPipeModule,
    EventSubmissionAnswerDialogModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatTableModule,
    ReactiveFormsModule,
    RouterModule,
    TtcMatPaginatorModule,
  ],
  declarations: [EventParticipantsComponent],
  exports: [EventParticipantsComponent],
  providers: [FormService],
})
export class EventParticipantsModule {}
